if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function updateCartQuantity(input, change) {
  const minAvailable = input.dataset.min;
  const maxAvailable = input.dataset.max;

  if (change === 0) {
    // Direct input change
    newQuantity = parseInt(input.value) || 1;
  } else {
    // Button click
    newQuantity = parseInt(input.value) + change;
  }

  // Ensure quantity is at least 1 and maximum available
  if (newQuantity < 1) newQuantity = minAvailable;
  if (newQuantity > maxAvailable) newQuantity = maxAvailable;

  // Update input value
  input.value = newQuantity;
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize button states for all quantity inputs
  const quantityInputs = document.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    // Add beforeinput event listener to prevent non-numeric input at the source
    input.addEventListener('beforeinput', function(e) {
      // Allow: backspace, delete, tab, escape, enter, and control keys
      if (e.inputType === 'deleteContentBackward' || 
          e.inputType === 'deleteContentForward' ||
          e.inputType === 'insertLineBreak' ||
          e.inputType === 'insertTab' ||
          e.ctrlKey || e.metaKey) {
        return;
      }
      
      // Block any input that is not a digit
      if (e.data && !/^[0-9]$/.test(e.data)) {
        e.preventDefault();
      }
    });
    
    // Add keydown event listener to block non-numeric keys
    input.addEventListener('keydown', function(e) {
      // Allow: backspace, delete, tab, escape, enter, arrow keys
      if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
          (e.ctrlKey && [65, 67, 86, 88, 90].indexOf(e.keyCode) !== -1)) {
        return;
      }
      
      // Block everything else except numbers (0-9)
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
    
    // Add compositionstart event to block IME input (for Vietnamese, Chinese, etc.)
    input.addEventListener('compositionstart', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add compositionupdate event to block IME input
    input.addEventListener('compositionupdate', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add compositionend event to block IME input
    input.addEventListener('compositionend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add keypress event listener as backup
    input.addEventListener('keypress', function(e) {
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (e.keyCode === 65 && e.ctrlKey === true) ||
          (e.keyCode === 67 && e.ctrlKey === true) ||
          (e.keyCode === 86 && e.ctrlKey === true) ||
          (e.keyCode === 88 && e.ctrlKey === true)) {
        return;
      }
      // Only allow numbers (0-9) - block everything else including accented characters
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
      }
    });

    input.addEventListener('keyup', function(e) {
      e.preventDefault();
      // const paste = (e.clipboardData || window.clipboardData).getData('text');
      const numericValue = e.target.value.replace(/[^0-9]/g, '');
      if (numericValue) {
        input.value = numericValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    // Add paste event listener to filter pasted content
    input.addEventListener('paste', function(e) {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      const numericValue = paste.replace(/[^0-9]/g, '');
      if (numericValue) {
        input.value = numericValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    // Add input event listener to remove any non-numeric characters
    input.addEventListener('input', function(e) {
      const value = e.target.value;
      // Remove any character that is not a digit
      const numericValue = value.replace(/[^0-9]/g, '');
      
      // If the value was changed (non-numeric characters removed), update the input
      if (value !== numericValue) {
        e.target.value = numericValue;
      }
    });
  });
});
